const dataAccessMethods = require('../../../dataAccessMethods');
const Blockly = require('blockly');
const baseMdcBlockGroup = require('../_BaseMdcBlockGroup');
const setupAddCodeProperties = require('../../../helpers/addCodeProperties');
const types = require('./types');
const logging = require('@sstdev/lib_logging');

const TOOLTIPS = {
    GeigerCounter: 'Number input, geiger Image and start/stop button to display Locate function',
    ImageView: 'Displays a single Image',
    JsonViewer: 'pretty print JSON',
    PrintPreview: 'Uses the nested  List Columns and information from the parent form to generate a Print Preview '
};

class _DataView extends baseMdcBlockGroup {
    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        if (types[hNodeType]?.convertCustomFieldsToCode) {
            const resultCode = types[hNodeType].convertCustomFieldsToCode(code, blocklyBlock);
            if (typeof resultCode === 'string') {
                logging.error(
                    `${hNodeType}.convertCustomFieldsToCode should not return a string. It should return a JSON object instead.`
                );
                return resultCode;
            }
            return JSON.stringify(resultCode);
        }
        const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
        addCodeProperties(['namespace', 'relation', 'propertyName']);

        if (hNodeType === 'GeigerCounter') {
            addCodeProperties([{ key: 'numBars', handler: parseInt }, 'sensorType']);
        }

        return JSON.stringify(code);
    }

    addToBlocksCustom(color, blocklyBlock, hNodeType, mdcBlock, topInput) {
        if (types[hNodeType]) {
            types[hNodeType].addBlockSpecificFields(color, blocklyBlock, mdcBlock, topInput);
            return;
        }
        let blockId = blocklyBlock.id;
        let workspace = blocklyBlock.workspace;

        if (TOOLTIPS[hNodeType]) {
            blocklyBlock.setTooltip(TOOLTIPS[hNodeType]);
        }

        if (hNodeType === 'GeigerCounter') {
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Number of Arcs:')
                .appendField(new Blockly.FieldTextInput('5'), 'numBars');

            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Sensor Type:')
                .appendField(
                    new Blockly.FieldDropdown([
                        ['ANY', 'ANY'],
                        ['RFID', 'RFID'],
                        ['BLE', 'BLE']
                    ]),
                    'sensorType'
                );
        } else {
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Namespace:')
                .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace');
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Relation:')
                .appendField(
                    new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)),
                    'relation'
                );
        }
        if (hNodeType === 'PrintPreview') {
            blocklyBlock.appendStatementInput('columns').setCheck(['listColumn']).appendField('List Columns:');
        } else if (hNodeType !== 'GeigerCounter') {
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Property Name:')
                .appendField(new Blockly.FieldTextInput(''), 'propertyName');
        }
    }

    customizeToolbox(section) {
        const blockForPrintPreview = section.contents.find(b => b.type === 'dataView_PrintPreview');

        if (blockForPrintPreview) {
            blockForPrintPreview.inputs = {
                columns: {
                    block: {
                        type: 'listColumn_Barcode',
                        fields: { title: '', propertyName: 'title' },
                        next: {
                            block: {
                                type: 'listColumn_Text',
                                fields: { title: '', propertyName: 'description' }
                            }
                        }
                    }
                }
            };
        }
    }
}
module.exports = _DataView;
